export default __webpack_public_path__ + "static/howto-2-2bfb71d87c75d8df4ee42e3d0efdcdab.jpg";